import React, { useState } from 'react';
import { useUISettings } from '../../context/UISettingsContext';
import { Button } from '../common/Button';

export function NewTokenModal({ isOpen, token, onClose }) {
  const [copied, setCopied] = useState(false);
  const { showNotification } = useUISettings();

  if (!isOpen) return null;

  const isUuid = token && token.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);

  const handleCopy = () => {
    navigator.clipboard.writeText(token);
    setCopied(true);
    showNotification('Token copied to clipboard!', 'success');
    setTimeout(() => setCopied(false), 2000);
  };

  const handleContinue = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <div className="text-center mb-6">
          <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-800">Login Successful!</h3>
        </div>
        
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
          <p className="text-sm text-yellow-700 font-semibold mb-2">
            ⚠️ IMPORTANT: Save your new session token
          </p>
          <p className="text-xs text-yellow-600">
            This token will be needed for your next login. It won't be shown again unless you use the "Show Token" button.
          </p>
        </div>
        
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Your New Session Token (UUID format):
          </label>
          <div className="flex">
            <input
              type="text"
              readOnly
              value={token}
              className="flex-1 p-3 bg-gray-100 border border-gray-300 rounded-l-lg font-mono text-sm"
            />
            <button
              onClick={handleCopy}
              className={`px-4 py-2 rounded-r-lg transition ${
                copied ? 'bg-green-500' : 'bg-blue-500 hover:bg-blue-600'
              } text-white`}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
          {!isUuid && (
            <p className="text-xs text-red-500 mt-2">
              Warning: This doesn't look like a valid UUID. Please contact support.
            </p>
          )}
        </div>
        
        <Button
          onClick={handleContinue}
          variant="success"
          fullWidth
          size="lg"
        >
          Continue to Chat
        </Button>
      </div>
    </div>
  );
}